import { Component, OnInit, DoCheck, OnDestroy, ViewChild } from '@angular/core';
import { BlockUI } from 'ng-block-ui';
import { Helpers } from '../../helpers';
import { SentToBidManagementSearchRequest, TenderSummaryDto } from '../../models/tenders/tender.models';
import { TenderService } from '../../services/tender.service';
import {IPage} from '../../models/common/paging';
import {Configuration} from '../../configuration';
import { SelectableItem } from '../../models/common/selectableItem';
import { SortOption } from '../../models/tenders/sort.option';

@Component({
    selector: 'tenders/sentToBidManagement',
    template: require('./sent.to.bid.management.component.html'),
    styles: [require('./sent.to.bid.management.component.css')]
})
export class SentToBidManagementComponent implements OnInit, DoCheck, OnDestroy {
    private previousRequest: SentToBidManagementSearchRequest;
    request: SentToBidManagementSearchRequest;
    results: IPage<TenderSummaryDto> = null;

    resultOptions;

    options: Array<SelectableItem<number>>;
    sortOptions = <SortOption[]>[];
    selectedSortOption: SortOption;
    sortOptionId: number;

    @BlockUI('tender-results-block') private resultsBlock;

    @ViewChild('resultsPage', { static: false }) private resultsView;

    constructor(configuration: Configuration, private readonly helpers: Helpers, private readonly tenderService: TenderService) {
        this.request = new SentToBidManagementSearchRequest(configuration);
        this.previousRequest = this.helpers.clone(this.request);

        this.resultOptions = {
            availableButtons: ['print']
        };

        this.sortOptionId = 1;
        this.selectedSortOption = {
            id: 1,
            sortProperty: 'DeadlineDate',
            descending: false
        };
        this.sortOptions = [
            this.selectedSortOption,
            { id: 2, sortProperty: 'DeadlineDate', descending: true },
            { id: 3, sortProperty: 'Type', descending: false },
            { id: 4, sortProperty: 'Title', descending: false }
        ];
        this.options = [
            { text: 'Nearest Deadline Date', value: 1 },
            { text: 'Furthest Deadline Date', value: 2 },
            { text: 'Type', value: 3 },
            { text: 'Title', value: 4 }
        ];

        this.request.sortProperty = this.selectedSortOption.sortProperty;
        this.request.descending = this.selectedSortOption.descending;
    }

    ngOnInit() {
        document.querySelector('body').classList.add('training-search-fit');
        this.search();
    }

    ngOnDestroy() {
        document.querySelector('body').classList.remove('training-search-fit');
    }

    ngDoCheck() {
        if (!this.request.equals(this.previousRequest)) {
            this.search();
        }
    }

    sortOptionChanged() {
        var id = +this.sortOptionId;
        this.selectedSortOption = this.sortOptions.find((option: SortOption) => {
            return option.id === id;
        });

        this.request.sortProperty = this.selectedSortOption.sortProperty;
        this.request.descending = this.selectedSortOption.descending;

        this.search();
    }

    search() {
        if (this.previousRequest.pageNumber === this.request.pageNumber) {
            this.request.pageNumber = 0;
        }

        this.resultsBlock.start();

        this.previousRequest = this.helpers.clone(this.request);

        this.tenderService.getSentToBidManagement(this.request).subscribe((results: IPage<TenderSummaryDto>) => {
            this.results = results;

            if (this.resultsView) {
                this.resultsView.onSearchComplete();
            }

            this.resultsBlock.stop();
        }, () => this.resultsBlock.stop());
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/tenders/sent.to.bid.management.component.ts